/**
 * defa.collections.Users
 * A Collection of Users with custom filters.
 * @version 1.2.0
 */
import User from 'scripts/defa/users/model-user';

const Users = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model: User,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Returns a new Users collection filtered by an array of ids.
	 * @param  {array}              ids  An array of ids to filter the collection by.
	 * @return {UserCollection}      The filtered UserCollection.
	 */
	filterByIds: function ( ids ) {
		let array = this.filter( function ( user ) {
			return _.contains( ids, user.get( 'id' ) );
		} );
		
		return new Users( array );
	},
} );

export default Users;